import { ModuleWithProviders, NgModule } from '@angular/core'
import { DynamicElementConfigs, DYNAMIC_ELEMENT_CONFIGS } from './models'
import { DynamicElementToHtmlPipe } from './pipes'
import { DataToInnerHtmlInterceptor, DataToTextInterceptor, DynamicElements } from './services'

@NgModule({
  providers: [
    DataToInnerHtmlInterceptor,
    DataToTextInterceptor
  ],
  imports: [
    DynamicElementToHtmlPipe
  ],
  exports: [
    DynamicElementToHtmlPipe
  ]
})
export class DynamicElementModule {

  static forRoot(configs: DynamicElementConfigs): ModuleWithProviders<DynamicElementModule> {
    return {
      ngModule: DynamicElementModule,
      providers: [
        { provide: DYNAMIC_ELEMENT_CONFIGS, useValue: configs, multi: true },
        DynamicElements
      ]
    }
  }

}
